<template>
    <div class="vertical grow gallery-container" style="width: 70vw; height: 100%">
        <div class="two-columns-template-modal" style="margin-top: 5px;">
            <div>
                <div v-if="(existingProblem == null && systemId == null)" class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('Farm')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <select v-model="selectedObject.farmId" @change="farmChanged">
                                <option v-for="v in farms" :key="v.id" :value="v.id">
                                    {{v.name}}
                                </option>
                            </select>
                        </td>
                    </tr>
                </div>
                <div v-if="(existingProblem != null)" class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('System')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{existingProblem.systemName}}</span>
                        </td>
                    </tr>
                </div>
                <div v-else-if="(systemName != null)" class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('System')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{systemName}}</span>
                        </td>
                    </tr>
                </div>
                <div v-else-if="(selectedObject.farmId != null)" class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('System')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <select v-model="selectedObject.systemId" @change="systemChange">
                                <option v-for="s in systems" :key="s.id" :value="s.id">
                                    {{s.name}}
                                </option>
                            </select>
                        </td>
                    </tr>
                </div>
                <div v-if="(existingProblem != null)" class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('Device')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{existingProblem.deviceName}}</span>
                        </td>
                    </tr>
                </div>
                <div v-else-if="(selectedObject.systemId != null)" class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('Device')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <input v-model="selectedObject.deviceId" type="text" :placeholder="$t('Device')" list="devices">
                            <datalist id="devices">
                              <option v-for="(device, index) in devices" :key="index">
                                {{device.number}}
                              </option>
                            </datalist>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('Title')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <input v-model="selectedObject.title" type="text" :placeholder="$t('Title')"/>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('Description')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <textarea v-model="selectedObject.description" type="text" :placeholder="$t('Description')"/>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('Photos')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <input type="file" id="problemPhotoId" name="problemPhoto" accept="image/*" @change.prevent="addPhoto" multiple>
                        </td>
                    </tr>
                </div>
                <div style="justify-content: center; margin-bottom: 10px;"  class="horizontal">
                    <div class="error" v-if="error != ''">{{ error }}</div>
                </div>
            </div>
            <div style="background-color: rgba(243, 243, 243, 1)">
                <div id="photos-container" style="margin: auto;">
                    <div class="vertical" style="margin: auto;">
                        <div style="width: calc(0.5 * 70vw); height: 50vh; align-self: center; text-align: center; overflow: hidden; white-space: nowrap;" v-if="(photos.length > 0)">
                            <i class="arrow left" :style="[photos.length > 1 ? {'cursor': 'pointer' } : {'cursor': 'default'}]" @click="changePhoto(-1)"></i>
                            <img class="photo" :src="photos[activePhotoIndex].url" >
                            <i class="arrow right" :style="[photos.length > 1 ? {'cursor': 'pointer' } : {'cursor': 'default'}]" @click="changePhoto(1)"></i>
                        </div>
                        <div class="thumbnails horizontal" style="padding-bottom: 10px;">
                            <div v-for="(photo, index) in photos" :key="index" @click="activePhotoIndex = index">
                                <div class="thumbnail-container">
                                    <img class="delete-image" src="~@/assets/img/Visits/Delete.svg" @click="deletePhoto(index)">
                                    <img :src="photo.url" class="thumbnail" v-bind:class="{ selectedThumbnail: activePhotoIndex == index}"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="align-self: center; margin-bottom: 20px;">
            <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="save"></Button>
        </div>
    </div>
</template>

<script>
import { getFarms, getProblemPhotos, getSystemsForFarm, saveProblem, editProblem, getSystemDevices, deleteResourceFromProblem } from '@/api/api';
import DatePicker from 'vue2-datepicker';
import Button from '@/components/Button.vue';
import moment from 'moment'

export default {
    props: {
        existingProblem: {
            required: false,
            default: null,
            type: Object
        },
        systemName: {
            required: false,
            default: null,
            type: String
        },
        systemId:  {
            required: false,
            default: null,
            type: String
        }
    },
    components: {
        DatePicker,
        Button
    },
    data() {
        return {
            selectedObject: {
                deviceId: null,
                systemId: null,
                visitId: null,
                description: null,
                title: null
            },

            error: '',
            farms: [],
            systems: [],
            devices: [],
            photos: [],
            activePhotoIndex: 0
        }
    },
    methods: {
        async getData() {
            // TODO add autofilling farmId and system when systemId != null
            if(this.systemId != null) {
                this.selectedObject.systemId = this.systemId
                this.systemChange()
                return
            }

            var farms = await getFarms()
            farms = farms.filter(x => x.name != null && x.name != '')
            this.farms = farms.sort(this.sortSystemsByName)
        },
        async loadExistingProblem() {
            this.selectedObject = Object.assign({}, this.existingProblem)

            for (let i = 0; i < this.selectedObject.resources.length; i++) {
                let img = await getProblemPhotos(this.selectedObject.resources[i]);
                let photo = URL.createObjectURL(new Blob([img.data], {
                type: img.headers['content-type']}));

                this.photos.push({
                    src: img,
                    url: photo,
                    id: this.selectedObject.resources[i]
                });
            }
        },
        async edit() {
            if (this.selectedObject.resolvedDate == null) {
              this.selectedObject.resolvedDate = '0001-01-01';
            }
            
            var toSend = Object.assign({}, this.selectedObject)
            toSend.reportedDate = moment(toSend.reportedDate).format('YYYY-MM-DD')
            toSend.creatorId = this.$store.getters.user.userId

            if(this.devices.length > 0) {
                var element = this.devices.filter(x => x.number == this.selectedObject.deviceId)
                if(element.length > 0) {
                    toSend.deviceId = element[0].id
                }
            }

            var form = new FormData()
            var keys = Object.keys(toSend)
            for(let i = 0; i < keys.length; i++){
                form.append(keys[i], toSend[keys[i]])
            }

            var photosSrc = this.photos.filter(x => x.id == undefined).map(x => x.src)
            for(let i = 0; i < photosSrc.length; i++) {
                form.append("resources", photosSrc[i])
            }

            await editProblem(form)

            var existingPhotosIds = this.photos.filter(x => x.id != undefined).map(x => x.id);
            var photosToDelete = this.existingProblem.resources.filter(x => !existingPhotosIds.includes(x))

            for(let i = 0; i < photosToDelete.length; i++) {
                await deleteResourceFromProblem(photosToDelete[i]);
            }

            this.$emit('saved')
        },
        async save() {
            this.validate()

            if(this.error != '') {
                return;
            }

            if(this.existingProblem != null) {
                this.edit();
                return;
            }

            var toSend = Object.assign({}, this.selectedObject)
            toSend.reportedDate = moment(Date.now()).format('YYYY-MM-DD')
            toSend.creatorId = this.$store.getters.user.userId

            if(this.devices.length > 0) {
                var element = this.devices.filter(x => x.number == this.selectedObject.deviceId)
                if(element.length > 0) {
                    toSend.deviceId = element[0].id
                }
            }

            var form = new FormData()
            var keys = Object.keys(toSend)
            for(let i = 0; i < keys.length; i++){
                form.append(keys[i], toSend[keys[i]])
            }

            var photosSrc = this.photos.map(x => x.src)
            for(let i = 0; i < photosSrc.length; i++) {
                form.append("resources", photosSrc[i])
            }

            await saveProblem(form)
            this.$emit('saved')
        },
        async farmChanged() {
            var farmId = this.selectedObject.farmId

            var systemsForFarm = await getSystemsForFarm(farmId)
            systemsForFarm = systemsForFarm.filter(x => x.name != null && x.name != '')
            this.systems = systemsForFarm.sort(this.sortSystemsByName)
        },
        async systemChange() {
            var systemId = this.selectedObject.systemId
            this.selectedObject.deviceId = ''

            this.devices = await getSystemDevices(systemId)
            this.devices = this.devices.sort((a, b) => a.number - b.number)
        },
        sortSystemsByName(a, b){
			return (a.name.localeCompare(b.name, undefined, {
              numeric: true,
              sensitivity: 'base'
            }));
		},
        deletePhoto(index) {
            this.activePhotoIndex = this.activePhotoIndex == index ? index > 1 ? index - 1 : 0 : this.activePhotoIndex;
            this.photos.splice(index, 1);
        },
        changePhoto(direction){
            if(direction > 0){
                if (this.activePhotoIndex + 1 < this.photos.length) {
                    this.activePhotoIndex++;
                } else {
                    this.activePhotoIndex = 0;
                }
            } else {
                if (this.activePhotoIndex > 0) {
                    this.activePhotoIndex--;
                } else {
                    this.activePhotoIndex = this.photos.length - 1
                }
            }
        },
        addPhoto(e){
            for(let i = 0; i < e.target.files.length; i++ ) {
                var photo = URL.createObjectURL(e.target.files[i]);
                this.photos.push({
                    src: e.target.files[i],
                    url: photo
                });
            }
            this.activePhotoIndex = this.photos.length - 1
        },
        validate() {
            this.error = ""

            if (this.existingProblem == null) {
                if (!this.farms.map(x => x.id).includes(this.selectedObject.farmId)) {
                    this.error = this.$t("SelectFarmBeforeSaving")
                    return
                }

                if (!this.systems.map(x => x.id).includes(this.selectedObject.systemId)) {
                    this.error = this.$t("SelectSystemBeforeSaving")
                    return
                }

                if (!this.devices.map(x => x.id).includes(this.selectedObject.deviceId) && this.selectedObject.deviceId.trim() == '') {
                    this.error = this.$t("SelectDeviceBeforeSaving")
                    return
                }
            }

            if (this.selectedObject.title == null || this.selectedObject.title.trim() == '') {
                this.error = this.$t("SelectTitleBeforeSaving")
                return
            }

            if (this.selectedObject.description == null || this.selectedObject.description.trim() == '') {
                this.error = this.$t("SelectDescriptionBeforeSaving")
                return
            }
        }
    },
    async mounted() {
        if(this.existingProblem != undefined && this.existingProblem != null) {
            this.loadExistingProblem()
        } else {
            this.getData()
        }
    }
}
</script>

<style scoped>
.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.section-title {
    font-weight: bold;
    text-align: center;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
    justify-content: center;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    align-self: center;
    width: 80%;
    margin: 0;
    padding-bottom: 5px;
}

.section-title {
    font-weight: bold;
}

select {
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

textarea {
    height: 200px;
    max-height: 300px;
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

input[type="text"] {
    max-height: 300px;
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}


.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  width: 4%;
  height: 0;
  padding-bottom: 4%;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.photo {
    margin: 0 auto 0 auto;
    border-radius: 4px;
    object-fit: contain;
    width: 88%;
    height: 100%;
}

.thumbnails {
    overflow-y: hidden;
    overflow-x: scroll;
    max-width: 80%;
    margin: 0 auto 20px auto;
}


.blurred {
    opacity: 0.5;
    width: 100%;
    height: 37px;
}

.selected {
    width: 100%;
    height: 50px;
}

.problem-section {
    justify-content: space-between;
    align-items: baseline;
    width: 100%;
}

.icon-desc {
    white-space: pre;
    text-align: center;
}

.selectedThumbnail {
    border: 4px solid #34758E;
}


.delete-image {
    width: 15px;
    height: 15px;
    cursor: pointer;
    position: relative;
    right: 0;
    top: 0;
    z-index: 1;
}

.thumbnail-container {
    position: relative;
    top: 0;
    left: 0;
    width: 64px;
    height: 64px;
    margin: 5px;
}

.thumbnail {
    width: 64px;
    height: 64px;
    margin: 5px;
    object-fit: cover;
    cursor: pointer;
    background: #34758E;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
}

.two-columns-template-modal {
    display: grid;
    grid-template-columns: 40% 60%;
}

#photos-container {
    width: 100%;
    align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Visits/Problems/ProblemModal.vue